import type IGoogleAnalyticVersion from "./IGoogleAnalyticsVersion";

/**
 * Google Analytic Version 4
 */
export class GoogleAnalytics4 implements IGoogleAnalyticVersion {
  pushEvent(event: any, category: any, action: any, label?: any, value?: any): void {
    const dataLayer = window.dataLayer || [];
    const ecomEvent = {
      event: event,
      [category]: action,
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(ecomEvent);
  }

  pushEcomData(ecommerceAction: string, ecommerceActionObj: any, event: string, actionField?: any): void {
    const dataLayer = window.dataLayer || [];
    const ecomEvent = {
      event: event,
      ecommerce: {
        [ecommerceAction]: ecommerceActionObj,
      },
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(ecomEvent);
  }

  pushEcomEvent(event: string, currency: string, value: number, items: object[]): void {
    window.dataLayer = window.dataLayer || [];
    const ecomEvent = { event, ecommerce: { currency, value, items } };
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(ecomEvent);
  }
}
